import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'receiptLink',
  initialState: null as string | null,
  reducers: {
    setReceiptLink(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setReceiptLink } = slice.actions;

export default slice.reducer;
